// extracted by mini-css-extract-plugin
export var body = "_2y-1";
export var bodyPadded = "_2y-2";
export var chevron = "_2y-4";
export var chevronOpen = "_2y-5";
export var header = "_2y-0";
export var icon = "_2y-3";